"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _lazyVideo = _interopRequireDefault(require("../../../elements/other/lazy-video"));
/**
 * Local Imports
 */

const VideoContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "VideoContainer",
  class: "pl-v1704dp"
});
const Video = /*#__PURE__*/(0, _react2.styled)(_lazyVideo.default)({
  name: "Video",
  class: "pl-v1p0c1nt"
});

/**
 * Renders a video card with a lazy-loaded video element.
 *
 * @param {Object} props React props
 * @param {String} props.introUrl Base URL for the video.
 * @param {String} props.introUrlWebm Base URL for the video webm.
 * @param {String} props.thumbnail Thumbnail image for the video.
 * @param {string} [props.preload='metadata'] Preload setting for the video load.
 * @returns {React.ReactElement|null} CardVideo Component
 */
function CardVideo({
  introUrl,
  introUrlWebm,
  thumbnail,
  preload
}) {
  if (!introUrl) return null;
  const videoSource = {
    fallback: thumbnail,
    base: introUrl,
    baseWebm: introUrlWebm
  };
  return /*#__PURE__*/_react.default.createElement(VideoContainer, {
    "data-cy": "inline-recore-video"
  }, /*#__PURE__*/_react.default.createElement(Video, {
    videoSource: videoSource,
    preload: preload,
    loop: true,
    autoPlay: true
  }));
}
var _default = exports.default = CardVideo;
CardVideo.propTypes = {
  introUrl: _propTypes.default.string,
  introUrlWebm: _propTypes.default.string,
  thumbnail: _propTypes.default.string,
  preload: _propTypes.default.oneOf(['auto', 'metadata', 'none'])
};